import React from 'react';

import AntdAlert, { AlertProps } from 'antd/es/alert';

import '@common/react/scss/components/expandedLegend.scss';

interface Props extends AlertProps {
	className?: string;
	isOpen?: boolean;
}

const Alert: React.FC<Props> = ({
	className,
	isOpen = true,
	...props
}) => {
	return (
		<div className={`expanded-legend ${className || ''} ${isOpen ? 'expanded-legend__open' : ''}`}>
			<AntdAlert
				type="info"
				showIcon
				{...props}
			/>
		</div>
	);
};

export default Alert;
